<template>
  <b-form>
    <b-card>
      <b-card-text>
        <div v-if="formData.suppliers_type">
          <h6><strong>Satıcı Tipi</strong></h6>
          <p class="lead">
            {{ formData.suppliers_type }}
          </p>
          <hr>
        </div>
        <div v-if="formData.scode">
          <h6><strong>Satıcı Kodu</strong></h6>
          <p class="lead">
            {{ formData.scode }}
          </p>
          <hr>
        </div>
        <div v-if="formData.company">
          <h6><strong>Firma Adı</strong></h6>
          <p class="lead">
            {{ formData.company }}
          </p>
          <hr>
        </div>
        <div v-if="formData.name">
          <h6><strong>İlgili Kişi</strong></h6>
          <p class="lead">
            {{ formData.name }}
          </p>
          <hr>
        </div>
        <div v-if="formData.phone">
          <h6><strong>Telefon</strong></h6>
          <p class="lead">
            {{ formData.phone }}
          </p>
          <hr>
        </div>
        <div v-if="formData.fax">
          <h6><strong>Faks</strong></h6>
          <p class="lead">
            {{ formData.fax }}
          </p>
          <hr>
        </div>
        <div v-if="formData.email">
          <h6><strong>E-Posta</strong></h6>
          <p class="lead">
            {{ formData.email }}
          </p>
          <hr>
        </div>
        <div v-if="formData.website">
          <h6><strong>Web Adresi</strong></h6>
          <p class="lead">
            {{ formData.website }}
          </p>
          <hr>
        </div>
        <div v-if="formData.notes">
          <h6><strong>Ek Notlar</strong></h6>
          <p class="lead">
            {{ formData.notes }}
          </p>
          <hr>
        </div>
        <div v-if="formData.tax_office || formData.tax_number">
          <h6><strong>Vergi Dairesi / Vergi No</strong></h6>
          <p class="lead">
            {{ formData.tax_office }} {{ formData.tax_number }}
          </p>
          <hr>
        </div>
        <div v-if="formData.city || formData.district || formData.address">
          <h6><strong>Adres</strong></h6>
          <p class="lead">
            {{ formData.address }}
            <br>
            {{ formData.city }} {{ formData.district }}
          </p>
          <hr>
        </div>
      </b-card-text>
    </b-card>
    <b-button
      variant="primary"
      :to="'/suppliers/edit/' + formData.id"
    >
      Kartı Güncelle
    </b-button>
  </b-form>
</template>

<script>
import {
  BForm,
  BCard,
  BCardText,
  BButton,
} from 'bootstrap-vue'

export default {
  name: 'SuppliersView',
  components: {
    BForm,
    BCard,
    BCardText,
    BButton,
  },
  data() {
    return {
      formData: {
        scode: null,
        name: null,
        company: null,
        phone: null,
        fax: null,
        email: null,
        website: null,
        tax_office: null,
        tax_number: null,
        address: null,
        notes: null,
        id_suppliers_type: null,
        id_city: null,
        id_district: null,
      },
    }
  },
  computed: {
    supplierData() {
      return this.$store.getters['suppliers/getSupplier']
    },
  },
  watch: {
    supplierData(val) {
      this.setFormData(val)
    },
  },
  created() {
    this.getSupplier()
  },
  methods: {
    getSupplier() {
      this.$store.dispatch('suppliers/supplierView', this.$route.params.id)
    },
    setFormData(data) {
      this.formData = data
    },
  },
}
</script>
